import type { SavedPlan } from '../../store/plansStore';
import { MAX_PINS, MAX_PLAN_NAME } from '../../utils/urlParams';

/** Account params the page needs to resolve the tenant on a bare origin (local development). */
const KEEP_PARAMS = ['c', 'a', 'accountId', 'customerId'];

/**
 * Plain, readable share link (Decision hVVnlIqg): the same params the live URL uses
 * (cat, aud, price, kind, near=<radius>, pins, pn). Never any coordinates.
 */
export function buildShareUrl(plan: Pick<SavedPlan, 'name' | 'state' | 'pinnedMarkerIds'>, base: Location = window.location): string {
  const current = new URLSearchParams(base.search);
  const url = new URL(base.pathname || '/', base.origin);
  for (const key of KEEP_PARAMS) {
    const v = current.get(key);
    if (v) url.searchParams.set(key, v);
  }
  const { state } = plan;
  if (state.categories.length) url.searchParams.set('cat', state.categories.join(','));
  if (state.audience.length) url.searchParams.set('aud', state.audience.join(','));
  if (state.price) url.searchParams.set('price', state.price);
  if (state.kind) url.searchParams.set('kind', state.kind);
  if (state.near) url.searchParams.set('near', String(state.near.radius_m));
  if (plan.pinnedMarkerIds.length) url.searchParams.set('pins', plan.pinnedMarkerIds.slice(0, MAX_PINS).join(','));
  url.searchParams.set('pn', plan.name.trim().slice(0, MAX_PLAN_NAME));
  return url.toString();
}
